<template>
  <div>
    <breadcrumb :breadcrumb="breadcrumb" />
    <text-title :mainTitle="mainTitle" :subheading="subheading" />
    <form>
      <div class="form-line">
        <div class="textBox">
          <b class="red">*</b>
          <span class="line-text">领用人：</span>
        </div>
        <el-input v-model="formData.personName" size="small" style="width: 280px" />
      </div>
      <div class="form-line">
        <div class="textBox">
          <span class="line-text">领用人住户：</span>
        </div>
        <el-input v-model="formData.enterpriseName" size="small" style="width: 280px" />
      </div>
      <div class="form-line">
        <div class="textBox">
          <b class="red">*</b>
          <span class="line-text">物资名称：</span>
        </div>
        <el-select v-model="materialsCode"
                   filterable
                   remote
                   reserve-keyword
                   size="small" style="width: 280px"
                   :remote-method="remoteMethod"
                   placeholder="请选择物资名称">
          <el-option v-for="item in materialsList" :key="item.code"
                     :label="item.materialsText" :value="item.code">
          </el-option>
        </el-select>
      </div>
      <div class="form-line">
        <div class="textBox">
          <b class="red">*</b>
          <span class="line-text">领用数量：</span>
        </div>
        <el-input v-model="formData.applyNumber" size="small" style="width: 280px" />
      </div>
      <div class="form-line">
        <div class="textBox">
          <span class="line-text">备注：</span>
        </div>
        <el-input v-model="formData.memo" type="textarea" size="small" style="width: 280px" />
      </div>
    </form>
      <div class="form-btn-box">
        <button-confirm @confirm="confirm" />
        <button-cancel @cancel="cancel" />
      </div>
  </div>
</template>

<script>
import Breadcrumb from "../../../components/Breadcrumb/Breadcrumb";
import TextTitle from "../../../components/Text/TextTitle";
import ButtonConfirm from "../../../components/Button/ButtonConfirm";
import ButtonCancel from "../../../components/Button/ButtonCancel";
import { getObjectURL } from "../../../utils/toBase64";
import { bus } from "../../../utils/bus";
import { api } from "../../api/Material";
import { nError, nSuccess } from "../../../utils/notice";
import { errorHandler } from "../../../utils/errorHandler";
export default {
  components: {
    ButtonCancel,
    ButtonConfirm,
    TextTitle,
    Breadcrumb
  },
  name: "material-requisition-add",
  data() {
    return {
      breadcrumb: [
        {
          value: "物资管理",
          name: "material-category-manage"
        },
        {
          value: "物资领用"
        }
      ],
      mainTitle: "添加物资领用",
      subheading: "",
      formData: {
        personName: "",
        enterpriseName: "",
        categoryCode: "",
        materialsCode: "",
        applyNumber: "",
        materialsNumber: "",
        memo: ""
      },
      materialsCode: "",
      categoryList: [],
      materialsList: []
    };
  },
  created() {
    this.remoteMethod();
  },
  methods: {
    remoteMethod(query) {
      this.getMaterialsList(query);
    },
    getMaterialsList(searchKey) {
      this.$axios
        .post(api.getMaterialsList, { searchKey: searchKey || "" })
        .then(res => {
          if (res.data.retCode === 1) {
            let list = res.data.data;
            list.map(v => {
              if(!v.specification){
                v.specification='无'
              }
              v.materialsText =
                v.materialsName +
                " / " +
                v.specification +
                " / " +
                v.categoryName +
                " / " +
                v.leftNumber +
                v.measureUnit;
              v.code = v.manageCode + "/" + v.categoryCode;
            });
            this.materialsList = list;
          }
        })
        .catch(errorHandler("获取物资类目列表失败"));
    },
    confirm() {
      if (!this.formData.personName) {
        nError("请输入领用人");
        return false;
      }
      if (!this.formData.materialsName) {
        nError("请选择物资名称");
        return false;
      }
      if (!this.formData.applyNumber) {
        nError("请输入领用数量");
        return false;
      }
      this.$axios
        .post(api.addApply, this.formData)
        .then(res => {
          if (res.data.retCode === 1) {
            nSuccess("添加成功");
            this.$router.push({
              name: "material-requisition"
            });
          }
        })
        .catch(errorHandler("添加失败"));
    },
    cancel() {
      this.$router.push({
        name: "material-requisition"
      });
    }
  },
  watch: {
    materialsCode(val) {
      this.materialsList.map(v => {
        if (v.code === val) {
          this.formData.categoryCode = v.categoryCode;
          this.formData.manageCode = v.manageCode;
          this.formData.materialsName = v.materialsName;
        }
      });
    }
  }
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/view/MaterialManagement/MaterialRequisition/MaterialRequisitionAdd.vue